__webpack_require__.p = "https://admin.qa.core-artifacts.com/static/";